var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.subscriptionProduct
    ? _c(
        "b-card-group",
        {
          staticClass: "mx-lg-2 h-100",
          attrs: { id: "subscription-downgrade-card", deck: "" }
        },
        [
          _c(
            "b-card",
            {
              class: `paid-subs-info-card mb-0 sub-card mx-1 ${
                _vm.isNewPlan ? "new" : "current"
              }`,
              attrs: {
                "body-class": "subs-info-card-body",
                "data-test-hook": "downgrade-subscription-card"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "plan-header",
                            attrs: { "data-test-hook": "downgrade-plan-header" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isNewPlan
                                    ? _vm.subscriptionProduct.name
                                    : _vm.subscriptionProduct
                                        .subscriptionProductName
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2682594584
              )
            },
            [
              _c(
                "b-row",
                { staticClass: "align-items-center mb-2 mx-0" },
                [
                  _c(
                    "b-col",
                    { staticClass: "px-0" },
                    [
                      _vm.isNewPlan
                        ? _c(
                            "b-badge",
                            {
                              staticClass: "plan-badge",
                              attrs: {
                                variant: "primary",
                                "data-test-hook":
                                  "downgrade-subscription-card-new-plan-badge"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("xNewPlan")))]
                          )
                        : _c(
                            "b-badge",
                            {
                              staticClass:
                                "border-primary text-primary plan-badge",
                              attrs: {
                                variant: "light",
                                "data-test-hook":
                                  "downgrade-subscription-card-current-plan-badge"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("xCurrentPlan")))]
                          )
                    ],
                    1
                  ),
                  _c("b-col", { staticClass: "px-0 price" }, [
                    _c(
                      "span",
                      {
                        staticClass: "mb-0 pb-0",
                        attrs: {
                          "data-test-hook": "downgrade-subscription-card-cost"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "price",
                            staticStyle: { "font-size": "1.75rem" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.isNewPlan
                                    ? _vm.subscriptionProduct.cost
                                    : _vm.subscriptionProduct.subscriptionCost
                                )
                              )
                            )
                          ]
                        )
                      ]
                    ),
                    _c("span", { staticClass: "yearly ml-1" }, [
                      _vm._v(
                        " /" +
                          _vm._s(
                            _vm.displayPlanCostCycle(
                              _vm.isNewPlan
                                ? _vm.subscriptionProduct.durationInMonths
                                : _vm.subscriptionProduct
                                    .subscriptionDurationInMonths
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "subscriptionCardText" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "strong",
                          {
                            attrs: {
                              "data-test-hook":
                                "existing-subscription-modal-premium-monitoring-max-products-text"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getMaxProductText(
                                    _vm.isNewPlan
                                      ? _vm.subscriptionProduct.productId
                                      : _vm.subscriptionProduct
                                          .subscriptionProductId
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._l(_vm.apparatusesToDowngrade, function(
                    apparatus,
                    index
                  ) {
                    return _c(
                      "b-row",
                      { key: index },
                      [
                        _c("b-col", { staticClass: "mt-2" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-fw fa-check-circle check-icon mr-2"
                            }),
                            _c("p", [_vm._v(_vm._s(apparatus.name))])
                          ])
                        ])
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }